import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row } from 'react-bootstrap';
import '../scss/NotFound.scss';

const NotFound = () => {

    const navigate = useNavigate();
    useEffect(() => {
        setTimeout(() => {
            navigate('/Register');
          }, 10000)
    }, []);

    return (
        <Container fluid="lg" className='wrapper'>
            <Row className="infoRow">

                <h1 id="header1">Page Not Found</h1>
                <h1 id="headerCode">404</h1>

                <h5>
                    The page you are looking for is not found. <a href="/Home" id="link-btn" >Back to Home</a>
                </h5>
                <h5>
                    You will be redirected to registration page in 10 seconds 
                    <br />
                    if no action is made.
                </h5>
                

            </Row>
        </Container>
    );
}

export default NotFound;